import { TableBody } from "@/components/ui/table";
import { CompetitiveBooleanRow } from "../CompetitiveBooleanRow";
import { URLAnalysis, BooleanCriteria } from "@/types/seo";

interface BooleanMetricsProps {
  urlAnalyses: URLAnalysis[];
}

export const BooleanMetrics = ({ urlAnalyses }: BooleanMetricsProps) => (
  <>
    {Object.entries(urlAnalyses[0].boolean_criteria).map(([key]) => (
      <CompetitiveBooleanRow 
        key={key} 
        metricKey={key as keyof BooleanCriteria} 
        analyses={urlAnalyses} 
      />
    ))}
  </>
);